import React from "react";
import { Link } from "react-router-dom";

import { useGlobalContext } from "../../context/context";
import logo from "../../assets/img/logo.png";

import "./navbar.css";

const Navbar = () => {
  const {
    openSidebar,
    isSidebar,
    closeSidebar,
  } = useGlobalContext();

  return (
    <header className="header">
      <button
        className={`header-backdrop ${isSidebar ? "active" : null}`}
        onClick={closeSidebar}
        aria-label="Close navigation menu"
        type="button"
      ></button>
      <nav className="navbar py-0">
        <div className="container navbar-inner">
          <div className="navbar-brand">
            <Link to="/" aria-label="Timbaktu home">
              <img className="logo" src={logo} alt="Timbaktu logo" />
            </Link>
          </div>
          <button
            onClick={openSidebar}
            type="button"
            className="navbar-toggle d-lg-none"
            aria-label={isSidebar ? "Close navigation menu" : "Open navigation menu"}
            aria-expanded={isSidebar}
            aria-controls="primary-navigation"
          >
            <i className="fa fa-bars"></i>
          </button>
          <div
            id="primary-navigation"
            className={`navbar-nav-container  py-lg-0 ${
              isSidebar ? "active" : null
            } `}
          >
            <button
              className="header-close-btn d-lg-none theme-bg fs-3 rounded-1 mx-3 mx-lg-0 mb-3 mb-lg-0 "
              onClick={closeSidebar}
              type="button"
              aria-label="Close navigation menu"
            >
              <i className="fa fa-times"></i>
            </button>
            <ul className="navbar-nav">
              
              <li className="nav-item">
                <Link
                  onClick={closeSidebar}
                  className="nav-link"
                  to="/courses"
                >
                  Our Courses
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  onClick={closeSidebar}
                  className="nav-link"
                  to="/digital-skills-stem"
                >
                  Digital Skills & STEM
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  onClick={closeSidebar}
                  className="nav-link"
                  to="/about"
                >
                 About Us
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  onClick={closeSidebar}
                  className="nav-link"
                  to="/why-choose-us"
                >
                  Why Choose Us
                </Link>
              </li>

              

              {/* <li className="nav-item">
                <Link
                  onClick={closeSidebar}
                  className="nav-link"
                  to="/blog-events"
                >
                  Blog & Events
                </Link>
              </li> */}

              <li className="nav-item">
                <Link
                  onClick={closeSidebar}
                  className="nav-link"
                  to="/contact"
                >
                  Contact Us
                </Link>
              </li>

              <li className="nav-item theme-btn">
                <Link
                  onClick={closeSidebar}
                  className="nav-link"
                  to="/signup"
                >
                  Register Now
                </Link>
              </li>

            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
